module.exports = __webpack_public_path__ + "9530447d8d5a66d7cd965620e66aaccf.MP3";